import { UserClaims } from "../../types/Claim";
import { del, post } from "../../utils/axios-config";
import { GET_USER_CLAIMS } from "../../utils/constants";

export const removeUserClaims = async (data:UserClaims)=>  await del<UserClaims, boolean>(GET_USER_CLAIMS, data);